import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/space/search-line.png';
import _imports_1 from '../../assets/space/empty-zone.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-b26dd1c2"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "space-page-container"
};
var _hoisted_2 = {
  class: "space-page"
};
var _hoisted_3 = {
  class: "space-left-block"
};
var _hoisted_4 = {
  class: "space-show-content"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "space-tips-title"
};
var _hoisted_7 = {
  class: "space-tips"
};
var _hoisted_8 = {
  class: "space-right"
};
var _hoisted_9 = {
  class: "space-right-top"
};
var _hoisted_10 = {
  class: "space-input"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_12 = [_hoisted_11];
var _hoisted_13 = {
  class: "space-middle"
};
var _hoisted_14 = {
  class: "empty-list"
};

var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "empty-list__img",
    src: _imports_1,
    alt: ""
  }, null, -1);
});

var _hoisted_16 = {
  key: 0
};
var _hoisted_17 = {
  key: 0,
  class: "empty-list__info"
};
var _hoisted_18 = {
  key: 1,
  class: "empty-list__info"
};

var _hoisted_19 = /*#__PURE__*/_createTextVNode(" 新建空间 ");

var _hoisted_20 = {
  key: 1,
  class: "empty-list__info"
};
var _hoisted_21 = ["onClick"];
var _hoisted_22 = ["src"];
var _hoisted_23 = {
  key: 0,
  class: "space-small-title"
};
var _hoisted_24 = {
  class: "space-border"
};
var _hoisted_25 = {
  class: "space-person-container"
};
var _hoisted_26 = {
  class: "user-name-container"
};
var _hoisted_27 = {
  key: 0
};
var _hoisted_28 = {
  key: 1
};
var _hoisted_29 = {
  class: "space-admin-member"
};
var _hoisted_30 = {
  class: "space-admin-member-btn"
};
var _hoisted_31 = {
  class: "space-admin-member-nums"
};
var _hoisted_32 = {
  key: 0,
  class: "space-title-rightOne"
};
var _hoisted_33 = ["onClick"];
var _hoisted_34 = {
  class: "space-right-footer"
};

var _hoisted_35 = /*#__PURE__*/_createTextVNode(" 新建空间 ");

var _hoisted_36 = {
  class: "space-pagination"
};
var _hoisted_37 = {
  class: "space-pagination__total"
};
var _hoisted_38 = {
  class: "space-pagination__page"
};
import { reactive, ref, computed, onMounted, watch } from 'vue';
import SpaceCreateDialog from './partials/space-create-dialog';
import SpaceCreateSuccessDialog from './partials/space-create-success-dialog';
import { ElMessage } from 'element-plus';
import CompanyService from '@/api/company';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex'; // tab列表的类型：2：我的空间；1：全部空间

export default {
  props: {
    // 首页介绍大图
    appPicture: {
      type: String,
      required: true
    },
    // 移动端首页介绍大图
    spaceHeaderLogoMobile: {
      type: String,
      required: true
    },
    // 空间logo
    spaceLogo: {
      type: String,
      required: true
    },
    // 首页产品介绍文字
    appDesc: {
      type: String,
      required: true
    },
    // 首页产品介绍文字标题
    appDescTitle: {
      type: String,
      required: true
    },
    // 创建空间提示语
    createSpaceTitle: {
      type: String,
      required: true,
      default: ''
    },
    // 拉取我的空间列表方法
    fetchSpaceList: {
      type: Function,
      required: true,
      default: function _default() {
        return function () {//
        };
      }
    },
    // 创建团队方法
    createSpace: {
      type: Function,
      required: true,
      default: function _default() {
        return function () {//
        };
      }
    },
    // 全部空间是否展示，默认展示
    allSpaceShow: {
      type: Boolean,
      default: true
    },
    // 新建空间按钮是否展示，默认展示
    createButtonShow: {
      type: Boolean,
      default: true
    },
    // 管理员是否展示为Name，默认展示loginName
    adminShowName: {
      type: Boolean,
      default: false
    },
    // 展示空间id
    showSpaceId: {
      type: Boolean,
      default: true
    },
    // 是否开启空间专属域名
    enableBizHost: {
      type: Boolean,
      default: true
    },
    // 创建时是否使用app
    useApp: {
      type: Boolean,
      default: true
    },
    corporationId: {
      type: String,
      default: ''
    },
    appKey: {
      type: String,
      default: ''
    }
  },
  emits: ['click-space', 'cancel'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var MENU_TYPE = {
      ALL: 1,
      SELF: 2
    };
    var store = useStore();
    var route = useRoute(); // 团队列表的类型：TAB：tab查询；SEARCH：搜索框

    var apiType = ref('tab'); // 搜索关键词

    var searchKey = ref(''); // 是否在loading

    var loading = ref(false); // tab列表的类型：2：我的空间；1：全部空间

    var menuType = ref(MENU_TYPE.SELF); // 空间序号自增id

    var applyDataId = ref(''); // 当前页面

    var pageNo = ref(1); // 总页数

    var totalPage = ref(''); // 是否为空列表

    var isEmpty = ref(false); // 空间列表

    var listData = reactive({
      list: []
    }); // 总条数

    var totalCount = ref(''); // 每页条数

    var pageSize = ref(7); // 空间列表

    var spaceList = reactive({
      bizList: [],
      totalCount: 0
    }); // 创建空间弹窗是否可见

    var createDialogVisible = ref(false); // 创建空间成功弹窗是否可见

    var createDialogSuccessVisible = ref(false); // 创建空间成功弹窗是否可见true

    var applyBizId = ref(''); // 空间名称

    var applyBizName = ref(''); // 企业名称

    var corporationName = ref(''); // 创建空间弹窗是否显示

    var ifShowCreateSuccess = ref(false); // 创建空间，将创建的bizId、bizName

    var createSuccessSpace = reactive({
      bizId: '',
      bizName: '',
      bizUrl: ''
    }); // computed
    // 判断是否是第一页

    var isFirstPage = computed(function () {
      if (pageNo.value === 1) return true;
      return false;
    }); // 判断是否是最后一页

    var isEndPage = computed(function () {
      if (pageNo.value === Math.ceil(totalCount.value / pageSize.value)) return true;
      return false;
    }); // 分页功能首页动态样式

    var firstPageFlag = computed(function () {
      if (isFirstPage.value) return 'disabled space-pagination__narrow-not-click';
      return 'space-pagination__narrow';
    }); // 分页功能尾页动态样式

    var endPageFlag = computed(function () {
      if (isEndPage.value) return 'disabled space-pagination__narrow-not-click';
      return 'space-pagination__narrow';
    }); // 计算总页数

    var getTotalPage = computed(function () {
      return Math.ceil(totalCount.value / pageSize.value);
    }); // 拉取全部/个人空间列表标识位

    var ifAll = computed(function () {
      return menuType.value === MENU_TYPE.ALL;
    });
    var isAdmin = computed(function () {
      return store.state.company.isAdmin;
    }); // methods

    var spacePageClick = function spacePageClick(isOwner, bizId, bizName, bizUrl) {
      if (!isOwner && menuType.value === MENU_TYPE.ALL) return false;
      emit('click-space', {
        bizId: bizId,
        bizName: bizName,
        bizUrl: bizUrl
      });
    };

    var goToSpace = function goToSpace(bizId, bizName, bizUrl) {
      emit('click-space', {
        bizId: bizId,
        bizName: bizName,
        bizUrl: bizUrl
      });
    }; // 创建空间弹窗是否显示方法


    var handleCreateSpaceShow = function handleCreateSpaceShow() {
      createDialogVisible.value = true;
    };

    var openNewBizModal = function openNewBizModal() {
      var newBiz = route.query.new_biz;

      if (isAdmin.value && newBiz === '1') {
        handleCreateSpaceShow();
      }
    }; // 关闭空间弹窗


    var handleClose = function handleClose() {
      createDialogVisible.value = false;
    };

    var onSpaceCreateSuccess = function onSpaceCreateSuccess(spaceInfo) {
      createDialogVisible.value = false;
      createDialogSuccessVisible.value = true;
      createSuccessSpace.value = spaceInfo;
    };
    /**
     * 根据条件拉取空间列表方法
     */


    var getSpaceList = function getSpaceList() {
      var pageNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pageNo.value;
      loading.value = true;
      var params = {
        ifAll: ifAll.value,
        pageNo: pageNum,
        pageSize: pageSize.value,
        keyword: searchKey.value
      };
      props.fetchSpaceList(params).then(function (res) {
        spaceList.bizList = res.bizList;
        isEmpty.value = res.totalCount === 0;
        totalCount.value = res.totalCount;
        listData.list = res.bizList;
      }).finally(function () {
        loading.value = false;
      });
    }; // 切换至前一页


    var prePage = function prePage() {
      if (isFirstPage.value) return;
      pageNo.value = pageNo.value - 1 < 1 ? 1 : pageNo.value - 1;
      getSpaceList(pageNo.value);
    }; // 切换至后一页


    var nextPage = function nextPage() {
      if (isEndPage.value) return;
      pageNo.value = pageNo.value + 1 > getTotalPage.value ? pageNo.value : pageNo.value + 1;
      getSpaceList(pageNo.value);
    };
    /**
     * 切换空间列表类型
     * @param { String } menuType tab类型
     */


    var switchTab = function switchTab(type) {
      menuType.value = type;
      isEmpty.value = false;
      searchKey.value = '';
      pageNo.value = 1;
      getSpaceList();
    }; // 通过关键词获取空间列表


    var getListBySearchKey = function getListBySearchKey() {
      apiType.value = 'SEARCH';

      if (!searchKey.value) {
        pageNo.value = 1;
        getSpaceList(1);
      }

      pageNo.value = 1;
      getSpaceList(1);
    };

    var getCorporationName = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return CompanyService.getCompanyInfo({
                  corporation_id: props.corporationId
                });

              case 2:
                result = _context.sent;

                if (result.data.code === 1) {
                  corporationName.value = result.data.result.corporation_name;
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getCorporationName() {
        return _ref2.apply(this, arguments);
      };
    }();

    watch(function () {
      return isAdmin.value;
    }, function () {
      openNewBizModal();
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              getSpaceList();
              _context2.next = 3;
              return getCorporationName();

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");

      var _component_el_button = _resolveComponent("el-button");

      var _component_user_filled = _resolveComponent("user-filled");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_el_popover = _resolveComponent("el-popover");

      var _component_arrow_left = _resolveComponent("arrow-left");

      var _component_arrow_right = _resolveComponent("arrow-right");

      var _component_el_dialog = _resolveComponent("el-dialog");

      var _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        src: __props.appPicture,
        alt: ""
      }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, _toDisplayString(__props.appDescTitle), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(__props.appDesc), 1)]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("h1", null, _toDisplayString(corporationName.value), 1), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
        class: _normalizeClass(["space-team-tab__switch", {
          'show-no-all': !__props.allSpaceShow
        }])
      }, [_createElementVNode("button", {
        class: _normalizeClass({
          'team-tab__item': true,
          'team-tab__item--active': menuType.value === MENU_TYPE.SELF
        }),
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return switchTab(MENU_TYPE.SELF);
        })
      }, " 空间列表 ", 2), __props.allSpaceShow ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: _normalizeClass({
          'team-tab__item': true,
          'team-tab__item--active': menuType.value === MENU_TYPE.ALL
        }),
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return switchTab(MENU_TYPE.ALL);
        })
      }, " 全部空间 ", 2)) : _createCommentVNode("", true)], 2), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_input, {
        modelValue: searchKey.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return searchKey.value = $event;
        }),
        size: "small",
        placeholder: "请输入空间名称进行搜索",
        class: "space-el-font",
        onKeyup: _withKeys(getListBySearchKey, ["enter"])
      }, {
        prefix: _withCtx(function () {
          return [_createElementVNode("i", {
            onClick: getListBySearchKey
          }, _hoisted_12)];
        }),
        _: 1
      }, 8, ["modelValue", "onKeyup"])])]), _createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("div", _hoisted_14, [_hoisted_15, apiType.value === 'tab' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [__props.createButtonShow ? (_openBlock(), _createElementBlock("p", _hoisted_17, "你还没有空间，快去创建吧~")) : (_openBlock(), _createElementBlock("p", _hoisted_18, "你还没有空间，联系管理员创建空间吧~")), __props.createButtonShow ? (_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        class: "btn-create-team",
        type: "text",
        onClick: handleCreateSpaceShow
      }, {
        default: _withCtx(function () {
          return [_hoisted_19];
        }),
        _: 1
      })) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("p", _hoisted_20, " 未搜索到任何空间，请修改查询条件重新搜索 "))], 512), [[_vShow, isEmpty.value && _unref(listData).list.length === 0]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(spaceList).bizList, function (item) {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: item.bizId,
          class: "space-right-middle",
          onClick: function onClick($event) {
            return spacePageClick(item.isOwner, item.bizId, item.bizName, item.bizUrl);
          }
        }, [_createElementVNode("img", {
          class: "space-biz-logo",
          src: __props.spaceLogo,
          width: "78",
          height: "78"
        }, null, 8, _hoisted_22), _createElementVNode("div", {
          class: _normalizeClass(["space-filling", {
            'hide-id': !__props.showSpaceId
          }])
        }, [_createElementVNode("h3", null, _toDisplayString(item.bizName), 1), __props.showSpaceId ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(item.bizId), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createVNode(_component_el_popover, {
          placement: "bottom-start",
          "popper-class": "space-page-biz-person-popover",
          title: "管理员",
          trigger: "hover",
          width: "270px"
        }, {
          reference: _withCtx(function () {
            return [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(_component_el_icon, {
              class: "space-admin-member-logo el-icon-user-solid"
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_user_filled)];
              }),
              _: 1
            }), _createElementVNode("span", _hoisted_31, _toDisplayString(item.admins.length), 1)])])];
          }),
          default: _withCtx(function () {
            return [_createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.admins, function (itemAdmins) {
              return _openBlock(), _createElementBlock("span", {
                key: itemAdmins.loginName
              }, [__props.adminShowName ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(itemAdmins.name) + _toDisplayString(';'), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(itemAdmins.loginName) + _toDisplayString(';'), 1))]);
            }), 128))])];
          }),
          _: 2
        }, 1024), menuType.value === MENU_TYPE.ALL && item.isOwner ? (_openBlock(), _createElementBlock("div", _hoisted_32, " 已有权限 ")) : menuType.value === MENU_TYPE.ALL && !item.isOwner ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "space-title-rightTwo",
          onClick: function onClick($event) {
            return _ctx.$emit('apply-auth', item.bizId);
          }
        }, " 申请加入 ", 8, _hoisted_33)) : _createCommentVNode("", true)])])], 2)], 8, _hoisted_21)), [[_vShow, _unref(listData).list.length > 0]]);
      }), 128))]), _withDirectives(_createElementVNode("div", _hoisted_34, [__props.createButtonShow ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "new-space-button",
        type: "text",
        onClick: handleCreateSpaceShow
      }, {
        default: _withCtx(function () {
          return [_hoisted_35];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_36, [_createElementVNode("span", _hoisted_37, "共 " + _toDisplayString(totalCount.value) + " 条记录", 1), _createElementVNode("span", {
        class: _normalizeClass(["el-icon-arrow-left", _unref(firstPageFlag)]),
        onClick: prePage
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_arrow_left)];
        }),
        _: 1
      })], 2), _createElementVNode("span", _hoisted_38, _toDisplayString(pageNo.value) + " / " + _toDisplayString(_unref(getTotalPage)), 1), _createElementVNode("span", {
        class: _normalizeClass(["el-icon-arrow-right", _unref(endPageFlag)]),
        onClick: nextPage
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_arrow_right)];
        }),
        _: 1
      })], 2)])], 512), [[_vShow, _unref(listData).list.length > 0]])])), [[_directive_loading, loading.value]]), _createVNode(_component_el_dialog, {
        "custom-class": "space-page-com-dialog",
        title: "新建空间",
        width: "540px",
        modelValue: createDialogVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return createDialogVisible.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_unref(SpaceCreateDialog), {
            ref: "form",
            "create-space": __props.createSpace,
            "create-space-title": __props.createSpaceTitle,
            "enable-biz-host": __props.enableBizHost,
            "use-app": __props.useApp,
            "app-key": __props.appKey,
            "corporation-id": __props.corporationId,
            onHandleClose: handleClose,
            onCreateSuccess: onSpaceCreateSuccess
          }, null, 8, ["create-space", "create-space-title", "enable-biz-host", "use-app", "app-key", "corporation-id"])];
        }),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: createDialogSuccessVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return createDialogSuccessVisible.value = $event;
        }),
        "custom-class": "create-success-dialog",
        width: "540px"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_unref(SpaceCreateSuccessDialog), {
            "space-info": _unref(createSuccessSpace),
            onEntrySpace: goToSpace
          }, null, 8, ["space-info"])];
        }),
        _: 1
      }, 8, ["modelValue"])])]);
    };
  }
};